import Button from '@/components/base/Button';

export default function NotFound() {
  return (
    <section className="w-full min-h-[70vh] flex items-center px-4 md:px-8 lg:px-12 pt-36 pb-20 bg-background-50">
      <div className="max-w-content mx-auto text-center flex flex-col items-center">
        <span className="font-label text-[11px] uppercase tracking-widest2 text-primary-400">
          Page not found
        </span>
        <h1 className="mt-5 font-heading text-4xl md:text-6xl text-foreground-950">
          This connection leads nowhere.
        </h1>
        <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600 max-w-xl">
          The page you&rsquo;re looking for doesn&rsquo;t exist or may have moved. Let&rsquo;s get you
          back on track.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Button to="/" variant="primary" size="lg">
            Back to Home
          </Button>
          <Button to="/contact" variant="outline" size="lg">
            Contact Us
          </Button>
        </div>
      </div>
    </section>
  );
}